import axiosInstance from '../../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../../common/tab/tabActions';
import moment from 'moment';
import { podeFinalizarOs, podeIniciarOs } from './ordemServicoUtils';

export { podeFinalizarOs, podeIniciarOs };

let finalizarOsOnSuccess = null;

const INITIAL_VALUES = { tipo: 'CORRETIVA', prioridade: 'MEDIA', status: 'ABERTA', grupo_fisico_filtro: '' };

function getErroIdNotificacao(notification) {
  return notification.id_erro || notification.id || null;
}

export function buildOsFormFromNotification(notification) {
  const controladorId = notification.controlador_id || notification.controlador_pk || null;
  const erroId = getErroIdNotificacao(notification);
  const grupoId = notification.grupo_fisico_id;
  const endereco = notification.endereco || notification.cruzamento || '';
  const grupoLabel =
    notification.nome_grupo_fisico || notification.grupo_fisico_descricao || (grupoId ? `Grupo ${grupoId}` : '');

  const titulo = `Erro Ctrl ${notification.numero_controlador || '—'}${
    notification.mensagem ? ` — ${String(notification.mensagem).substring(0, 50)}` : ''
  }`;

  const descricao = [
    `Notificação: ${notification.mensagem || 'N/A'}`,
    `Data: ${moment(notification.data_erro).format('DD/MM/YYYY')} ${notification.hora_erro || ''}`,
    grupoLabel ? `Grupo Físico: ${grupoLabel}` : null,
    `Controlador: ${notification.numero_controlador || '—'}`,
    endereco ? `Local: ${endereco}` : null,
  ]
    .filter(Boolean)
    .join('\n');

  return {
    ...INITIAL_VALUES,
    titulo,
    descricao,
    tipo: 'CORRETIVA',
    prioridade: 'ALTA',
    status: 'ABERTA',
    grupo_fisico_filtro: (grupoId !== null && grupoId !== undefined) && grupoId !== '' ? String(grupoId) : '',
    grupo_fisico_id: grupoId || null,
    numero_controlador: notification.numero_controlador || null,
    controlador_id: controladorId ? String(controladorId) : '',
    controlador_erro_id: erroId ? String(erroId) : '',
  };
}

export function buildOsFormFromControlador(controlador) {
  const grupoId = controlador.grupo_fisico_id;
  const local = controlador.cruzamento || controlador.endereco || '';
  const numero = controlador.numero_controlador;

  return {
    ...INITIAL_VALUES,
    titulo: `Manutenção — Ctrl ${numero || '—'}`,
    descricao: local ? `Local: ${local}` : '',
    tipo: 'CORRETIVA',
    prioridade: 'MEDIA',
    status: 'ABERTA',
    grupo_fisico_filtro: (grupoId !== null && grupoId !== undefined) && grupoId !== '' ? String(grupoId) : '',
    grupo_fisico_id: grupoId || null,
    numero_controlador: numero || null,
    controlador_id: controlador.id ? String(controlador.id) : '',
  };
}

export function showCreateFromControlador(controlador) {
  return dispatch => {
    const formValues = buildOsFormFromControlador(controlador);
    const controladorId = formValues.controlador_id;

    dispatch(getOpcoes());
    dispatch(clearMembrosEquipe());
    dispatch(clearNotificacoes());
    dispatch({ type: 'OS_SELECTED', payload: null });
    dispatch({ type: 'OS_PENDING_NAV', payload: true });
    dispatch(showTabs('tabList', 'tabCreate', 'tabGraficos', 'tabRelatorio'));
    dispatch(selectTab('tabCreate'));
    dispatch(initialize('ordemServicoForm', formValues));

    if (controladorId) {
      dispatch(getNotificacoesControlador(controladorId));
    }
  };
}

export function showCreateFromNotification(notification) {
  return dispatch => {
    const formValues = buildOsFormFromNotification(notification);
    const controladorId = formValues.controlador_id;

    dispatch(getOpcoes());
    dispatch(clearMembrosEquipe());
    dispatch(clearNotificacoes());
    dispatch({ type: 'OS_SELECTED', payload: null });
    dispatch(showTabs('tabList', 'tabCreate', 'tabGraficos', 'tabRelatorio'));
    dispatch(selectTab('tabCreate'));
    dispatch(initialize('ordemServicoForm', formValues));

    if (controladorId) {
      dispatch(getNotificacoesControlador(controladorId));
    }
  };
}

export function openOsFromMap(osId) {
  return openOsNaAba(osId, 'tabUpdate');
}

export function openOsMateriais(osId) {
  return openOsNaAba(osId, 'tabMateriais');
}

export function openOsInteracoes(osId) {
  return openOsNaAba(osId, 'tabInteracoes');
}

function openOsNaAba(osId, tab) {
  return dispatch => {
    dispatch({ type: 'OS_PENDING_NAV', payload: true });
    dispatch(getOpcoes());
    return axiosInstance
      .get(`/manutencao/ordens_servico/${osId}`)
      .then(resp => {
        dispatch(showUpdate(resp.data));
        if (tab && tab !== 'tabUpdate') {
          dispatch(selectTab(tab));
        }
        return resp.data;
      })
      .catch(() => {
        toastr.error('Erro', 'Não foi possível carregar a ordem de serviço.');
        dispatch({ type: 'OS_PENDING_NAV', payload: false });
        return null;
      });
  };
}

export function openFromNotification(notification, osResumo = null) {
  return dispatch => {
    dispatch({ type: 'OS_PENDING_NAV', payload: true });
    dispatch(getOpcoes());

    if (osResumo && osResumo.id) {
      return axiosInstance
        .get(`/manutencao/ordens_servico/${osResumo.id}`)
        .then(resp => {
          dispatch(showUpdate(resp.data));
          return resp.data;
        })
        .catch(() => {
          toastr.error('Erro', 'Não foi possível carregar a ordem de serviço.');
          dispatch(showCreateFromNotification(notification));
        });
    }

    dispatch(showCreateFromNotification(notification));
    return Promise.resolve(null);
  };
}

export { selectTab };

export function getList() {
  const request = axiosInstance.get('/manutencao/ordens_servico');
  return {
    type: 'OS_FETCHED',
    payload: request,
  };
}

export function getOpcoes() {
  return dispatch => {
    axiosInstance
      .get('/manutencao/opcoes')
      .then(resp => dispatch({ type: 'OS_OPCOES_FETCHED', payload: resp.data }))
      .catch(() => toastr.error('Erro', 'Não foi possível carregar as opções de formulário.'));
  };
}

export const setPaginaAtual = pagina => ({
  type: 'OS_PAGE',
  payload: pagina,
});

function toIntOrNull(v) {
  return v ? parseInt(v, 10) : null;
}

export function getNotificacoesControlador(controladorId) {
  return dispatch => {
    if (!controladorId) {
      dispatch({ type: 'OS_NOTIFICACOES_CLEAR' });
      return;
    }
    axiosInstance
      .get(`/manutencao/controladores/${controladorId}/notificacoes`, { params: { limit: 15 } })
      .then(resp => dispatch({ type: 'OS_NOTIFICACOES_FETCHED', payload: resp.data || [] }))
      .catch(() => {
        dispatch({ type: 'OS_NOTIFICACOES_CLEAR' });
        toastr.error('Erro', 'Não foi possível carregar as notificações do controlador.');
      });
  };
}

export function clearNotificacoes() {
  return { type: 'OS_NOTIFICACOES_CLEAR' };
}

export function getMembrosEquipe(equipeId) {
  return dispatch => {
    if (!equipeId) {
      dispatch({ type: 'OS_MEMBROS_CLEAR' });
      return;
    }
    axiosInstance
      .get(`/manutencao/equipes/${equipeId}/membros`)
      .then(resp => dispatch({ type: 'OS_MEMBROS_FETCHED', payload: resp.data || [] }))
      .catch(() => {
        dispatch({ type: 'OS_MEMBROS_CLEAR' });
        toastr.error('Erro', 'Não foi possível carregar os membros da equipe.');
      });
  };
}

export function clearMembrosEquipe() {
  return { type: 'OS_MEMBROS_CLEAR' };
}

function normalize(values) {
  const titulo = (values.titulo !== null && values.titulo !== undefined) ? String(values.titulo).trim() : '';
  const payload = {
    ...values,
    titulo,
    controlador_id: toIntOrNull(values.controlador_id),
    controlador_erro_id: toIntOrNull(values.controlador_erro_id),
    equipe_id: toIntOrNull(values.equipe_id),
    usuario_responsavel_id: toIntOrNull(values.usuario_responsavel_id),
    sla_horas: toIntOrNull(values.sla_horas),
    grupo_fisico_id: toIntOrNull(values.grupo_fisico_id),
    numero_controlador: toIntOrNull(values.numero_controlador),
  };
  delete payload.grupo_fisico_filtro;
  return payload;
}

export function createFromNotification(dados) {
  return dispatch => {
    return axiosInstance
      .post('/manutencao/ordens_servico', normalize(dados))
      .then(resp => {
        toastr.success('Sucesso', `OS ${resp.data.numero} aberta com sucesso.`);
        return resp.data;
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível abrir a ordem de serviço.');
        throw e;
      });
  };
}

export function create(values) {
  return submit(normalize(values), 'post');
}

export function update(values) {
  return submit(normalize(values), 'put');
}

export function remove(values) {
  return dispatch => {
    axiosInstance
      .delete(`/manutencao/ordens_servico/${values.id}`)
      .then(() => {
        toastr.success('Sucesso', 'Ordem de serviço removida com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível remover a ordem de serviço.');
      });
  };
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const url = method === 'put' ? `/manutencao/ordens_servico/${id}` : '/manutencao/ordens_servico';
    axiosInstance[method](url, values)
      .then(() => {
        toastr.success('Sucesso', 'Operação realizada com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível salvar a ordem de serviço.');
      });
  };
}

export function alterarStatusOs(os, novoStatus, onSuccess, opcoes = {}) {
  return dispatch => {
    if (!os || !os.id) return Promise.resolve(null);

    const body = { status: novoStatus };
    if (opcoes.devolver_estoque === true) {
      body.devolver_estoque = true;
    }

    return axiosInstance
      .put(`/manutencao/ordens_servico/${os.id}`, body)
      .then(resp => {
        const msg =
          novoStatus === 'CANCELADA' && opcoes.devolver_estoque
            ? 'OS cancelada e estoque devolvido.'
            : 'Status da ordem de serviço atualizado.';
        toastr.success('Sucesso', msg);
        if (typeof onSuccess === 'function') {
          onSuccess(resp.data);
        } else {
          dispatch(getList());
        }
        return resp.data;
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível atualizar o status da ordem de serviço.');
        return null;
      });
  };
}

export function iniciarOs(os, onSuccess) {
  return dispatch => {
    if (!podeIniciarOs(os)) return Promise.resolve(null);
    return dispatch(alterarStatusOs(os, 'EM_ATENDIMENTO', onSuccess));
  };
}

export function finalizarOs(os, onSuccess) {
  return dispatch => {
    if (!podeFinalizarOs(os)) return Promise.resolve(null);
    finalizarOsOnSuccess = typeof onSuccess === 'function' ? onSuccess : null;
    dispatch({ type: 'OS_FINALIZAR_OPEN', payload: os });
    return Promise.resolve(null);
  };
}

export function fecharFinalizarOs() {
  return dispatch => {
    finalizarOsOnSuccess = null;
    dispatch({ type: 'OS_FINALIZAR_CLOSE' });
  };
}

export function confirmarFinalizarOs(status, opcoes = {}) {
  return (dispatch, getState) => {
    const os = getState().manutencaoOS && getState().manutencaoOS.finalizarModalOs;
    if (!os || !status) return Promise.resolve(null);

    const onSuccess = finalizarOsOnSuccess;
    dispatch({ type: 'OS_FINALIZAR_CONFIRMANDO', payload: true });

    const payloadOpcoes =
      status === 'CANCELADA' && opcoes.devolver_estoque === true ? { devolver_estoque: true } : {};

    return dispatch(alterarStatusOs(os, status, onSuccess, payloadOpcoes))
      .then(result => {
        dispatch({ type: 'OS_FINALIZAR_CLOSE' });
        finalizarOsOnSuccess = null;
        return result;
      })
      .catch(() => {
        dispatch({ type: 'OS_FINALIZAR_CONFIRMANDO', payload: false });
        return null;
      });
  };
}

export function showUpdate(os) {
  return dispatch => {
    dispatch([
      showTabs('tabUpdate', 'tabMateriais', 'tabInteracoes'),
      selectTab('tabUpdate'),
      { type: 'OS_SELECTED', payload: os },
      initialize('ordemServicoForm', {
        ...os,
        grupo_fisico_filtro: os.grupo_fisico_id ? String(os.grupo_fisico_id) : '',
        controlador_id: os.controlador_id ? String(os.controlador_id) : '',
        equipe_id: os.equipe_id ? String(os.equipe_id) : '',
        usuario_responsavel_id: os.usuario_responsavel_id ? String(os.usuario_responsavel_id) : '',
        controlador_erro_id: os.controlador_erro_id ? String(os.controlador_erro_id) : '',
      }),
    ]);
    if (os.controlador_id) {
      dispatch(getNotificacoesControlador(os.controlador_id));
    } else {
      dispatch(clearNotificacoes());
    }
    if (os.equipe_id) {
      dispatch(getMembrosEquipe(os.equipe_id));
    } else {
      dispatch(clearMembrosEquipe());
    }
  };
}

export function showMateriais(os) {
  return dispatch => {
    dispatch({ type: 'OS_PENDING_NAV', payload: true });
    dispatch(showUpdate(os));
    dispatch(selectTab('tabMateriais'));
  };
}

export function showInteracoes(os) {
  return dispatch => {
    dispatch({ type: 'OS_PENDING_NAV', payload: true });
    dispatch(showUpdate(os));
    dispatch(selectTab('tabInteracoes'));
  };
}

export function clearPendingNavFromNotification() {
  return { type: 'OS_PENDING_NAV', payload: false };
}

export function init() {
  return dispatch => {
    dispatch({ type: 'OS_PENDING_NAV', payload: false });
    dispatch(getOpcoes());
    dispatch(clearNotificacoes());
    dispatch(clearMembrosEquipe());
    dispatch({ type: 'OS_SELECTED', payload: null });
    dispatch(showTabs('tabList', 'tabCreate', 'tabGraficos', 'tabRelatorio'));
    dispatch(selectTab('tabList'));
    dispatch(getList());
    dispatch(initialize('ordemServicoForm', INITIAL_VALUES));
  };
}
